import { createFileRoute } from '@tanstack/react-router';
import { lerBusca, MargensPage } from '@/components/margens';

export const Route = createFileRoute('/_app/precificar/margens')({
  validateSearch: (bruto: Record<string, unknown>) => lerBusca(bruto),
  component: MargensRota,
});

function MargensRota() {
  return <MargensPage busca={Route.useSearch()} />;
}
